/*
	OneMobileMenu 2.0.0 Usage (Webpack)
	yang @onerockwell
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import '../../styles/modules/oneMobileMenu.scss';

// Define the Backbone View here (Optional)
let OneMobileMenuView = Backbone.View.extend({
	
	initialize: function (settings) {
		
		console.log('init mobile menu');
		
		var self = this;
		self.$mobileNav = self.$el;
		self.$currentActive = false;
		self.openCallback = settings.openCallback ? settings.openCallback : function(){ console.log('open slide-in-menu callback') };
		self.closeCallback = settings.closeCallback ? settings.closeCallback : function(){ console.log('close slide-in-menu callback') };
	},

	events: {
		'terminate-inner-action' : function(e) {
			var self = this;
			if (self.$currentActive) {
				self.$currentActive.find('.back-to').trigger('click');
			}
		},
		'click [data-trigger]' : function(e){
			// Contorls level2 slide in sub-menu
			e.preventDefault();
			var self = this;
			var $trigger = $(e.currentTarget);
			var target = $trigger.data('trigger');
			var $target = self.$mobileNav.find('[data-target="' + target + '"]');
			
			if ( $target.length ) {
				$trigger.addClass('active');
				$target.addClass('active');
				self.$mobileNav.addClass('slide-menu-opened');
				self.openCallback();
				
				if ($target.find('input').length) {
					setTimeout(function(){ $target.find('input').focus(); },100);
				}

				self.$currentActive = $target;
			}
		},
		'click .back-to' : function(e){
			e.preventDefault();
			var self = this;
			var $backToBtn = $(e.currentTarget);
			var $target = $backToBtn.parent();
			var trigger = $target.data('target');
			var $trigger = self.$mobileNav.find('[data-trigger="' + trigger + '"]');
			
			self.$mobileNav.removeClass('slide-menu-opened');
			self.closeCallback();
			$target.removeClass('active');
			$trigger.removeClass('active');
			
			self.$currentActive = false;
		},
		'click .expandable > *:not(.children)' : function(e){
			e.preventDefault();
			var self = this;
			var $trigger = $(e.currentTarget);
			var $item = $trigger.parent('.expandable');
			var isCurrentlyOpen = $item.hasClass('active');
			var $openSiblings = $item.siblings('.expandable.active');

			$openSiblings.each(function(_, siblingNode){
				self.setExpandableState($(siblingNode), false);
			});

			self.setExpandableState($item, !isCurrentlyOpen);
		}
	},

	setExpandableState: function($item, shouldOpen) {
		var $children = $item.children('.children');
		if (!$children.length) return;

		$children.stop(true, false);
		if (shouldOpen) {
			$item.addClass('active');
			$children.slideDown(220);
		} else {
			$children.slideUp(220, function() {
				$item.removeClass('active');
			});
		}
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	}

});

// Define the module here 
let OneMobileMenu = {
	init: function (settings) {
		return new OneMobileMenuView(settings);
	}
}

// Output the module
export default OneMobileMenu;